import { useMemo } from "react"
import { useQuery } from "urql"

import { type Query, type Region, RegionListQueryDocument } from "@/graphql/codegen/graphql"

export interface UseGetRegionListReturn {
  regions: Region[] | any[]
  isRegionsFetching: boolean
}

export const useGetRegionList = (countryIsoCode: string): UseGetRegionListReturn => {
  const [{ data: regionsData, fetching: isRegionsFetching }] = useQuery<Pick<Query, "region">>({
    query: RegionListQueryDocument,
    variables: { input: { filter: { countryIsoCode }, limit: 100 } },
  })

  const regions = useMemo(() => {
    if (regionsData?.region.list.__typename === "RegionListSuccess") {
      return regionsData.region.list.regions
    }

    return []
  }, [regionsData])

  return {
    regions,
    isRegionsFetching,
  }
}
